export default function FloorPlanCalibrationDialog({
  calibDistance, setCalibDistance,
  calibUnit, setCalibUnit,
  handleCalibSubmit,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" data-testid="calib-dialog">
      <div className="bg-card border border-border rounded-sm p-6 w-80 space-y-4">
        <h3 className="text-sm font-heading text-foreground">Set Scale</h3>
        <p className="text-[10px] text-muted-foreground">Enter the real-world distance between the two points you selected.</p>
        <div className="flex items-center gap-2">
          <input type="number" step="0.01" min="0.01" value={calibDistance} onChange={e => setCalibDistance(e.target.value)}
            placeholder="10" autoFocus data-testid="calib-distance-input"
            className="flex-1 px-3 py-2 text-sm bg-secondary border border-border rounded-sm text-foreground focus:outline-none focus:border-primary/50" />
          <select value={calibUnit} onChange={e => setCalibUnit(e.target.value)} data-testid="calib-unit-select"
            className="px-3 py-2 text-sm bg-secondary border border-border rounded-sm text-foreground">
            <option value="ft">ft</option>
            <option value="in">in</option>
            <option value="m">m</option>
          </select>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={handleCalibSubmit} data-testid="calib-submit-btn"
            className="flex-1 px-4 py-2 text-xs font-heading uppercase bg-primary text-primary-foreground rounded-sm hover:bg-primary/90 transition-colors">
            Set Scale
          </button>
          <button onClick={onClose}
            className="px-4 py-2 text-xs text-muted-foreground hover:text-foreground transition-colors">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
